/**
 * Admin shell layout mode for touch / narrow viewports.
 * Use with useResponsiveLayout(): phones + tablets get card layouts, larger targets, hover-row off.
 * Desktop (≥1024px) keeps dense tables and hover feedback.
 */
export function isCompactAdminLayout(isMobile, isTablet) {
  return Boolean(isMobile || isTablet);
}

/**
 * "A finger is the pointer" (KAN-970). SIZES follow touch, LAYOUT follows width:
 * phones + tablets are always touch; a desktop-width viewport is touch only when the
 * primary pointer is coarse (iPad landscape 1180 / 1366). A mouse at any width on a
 * ≥1024 viewport stays false, so the desktop band is unchanged.
 */
export function isTouchLayout(isMobile, isTablet, coarse) {
  return Boolean(isMobile || isTablet || coarse);
}
